import moment from "moment";
import React from "react";
import { GetFileSourceLabel } from "./utils";

const ESignFileSourceInfo = ({ file }: { file: server.dto.ESignFile }) => {
  const timeAgo = moment.utc(file.createdUtc).fromNow();

  const fileSource = GetFileSourceLabel(file.fileSource);

  return <>
    <div className="text-sublabel">{fileSource} {RESX.ESign.inVersion} {file.version}</div>
    <div className="text-sublabel">{timeAgo} {RESX.RecordInformation.by} {file.createdUser.fullName}</div>
  </>;
};

export default ESignFileSourceInfo;